import { FC } from "react";
import { EmptyContentPartProps } from "@assistant-ui/react";
import styles from "./AssistantMessageEmpty.module.scss";

type Props = EmptyContentPartProps;

export const AssistantMessageEmpty: FC<Props> = () => (
  <div className={styles.dots} />
);
